var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerified(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "113px",
    height: "113px",
    viewBox: "0 0 113 113",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "verified") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MIC",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "MIC-AccountVerified",
    transform: "translate(-664.000000, -192.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page"
  }), /*#__PURE__*/React.createElement("g", {
    id: "verified",
    transform: "translate(664.000000, 192.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 113 0 113 113 0 113"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5,5 L14,23.7272727 L14,51.8181818 C14,77.8256818 32.1097222,102.0775 56.5,108 C80.8902778,102.0775 99,77.8256818 99,51.8181818 L99,23.7272727 L56.5,5 Z M47.0555556,79.9090909 L28.1666667,61.1818182 L34.8486111,54.5570455 L47.0555556,66.6595455 L78.1513889,35.8297727 L84.8333333,42.4545455 L47.0555556,79.9090909 Z",
    id: "Shape",
    fill: "#008448",
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerified);
export default __webpack_public_path__ + "static/media/verified.5600494ecfefc72e9b85a0de19ca4404.svg";
export { ForwardRef as ReactComponent };